import type { LucideIcon } from "lucide-react";
import { Card } from "@/shared/components/ui/card";

type DashboardKpiCardProps = {
  label: string;
  count: number;
  icon: LucideIcon;
};

export function DashboardKpiCard({
  label,
  count,
  icon: Icon,
}: DashboardKpiCardProps) {
  return (
    <Card className="border-border/60 bg-card/90 shadow-xs">
      <div className="flex items-center gap-4 p-5">
        <div className="flex size-11 items-center justify-center rounded-2xl border border-primary/15 bg-primary/5 text-primary">
          <Icon className="size-5" />
        </div>
        <div>
          <div className="text-3xl font-semibold tracking-tight text-foreground">
            {count}
          </div>
          <p className="text-sm text-muted-foreground">{label}</p>
        </div>
      </div>
    </Card>
  );
}
